<template>
  <div>
    <b-dropdown
      left
      :data-test="`dropdown-button-${index}`"
      variant="plain"
      toggle-class="text-decoration-none"
      no-caret
    >
      <template v-slot:button-content>
        <i class="fas fa-ellipsis-v" />
      </template>
      <b-dropdown-item
        :data-test="`reporting-link-${index}`"
        :to="{ name: this.isReportingDashboardV1Available ? 'MultipleReportingIndex' : 'GroupReportingApp',
               params: {
                 advertiserId,
                 group
               }
        }"
        :disabled="!hasViewReportingAccess || areAllCampaignsDraftOrReview || !statsDataIsPresent"
      >
        View Reporting
      </b-dropdown-item>
      <div
        v-if="optionIsVisible"
      >
        <b-dropdown-divider />
        <b-dropdown-item
          :data-test="`share-campaign-group-link-${index}`"
          @click="onShareCampaignGroupClick"
        >
          Share Campaign Group
        </b-dropdown-item>
        <b-dropdown-divider />
      </div>
      <div
        v-if="optionIsVisible"
      >
        <b-dropdown-item
          :data-test="`edit-campaign-group-link-${index}`"
          @click="onEditCampaignGroupClick"
        >
          Edit Campaign Group
        </b-dropdown-item>
        <b-dropdown-divider />
      </div>
      <div
        v-if="optionIsVisible"
      >
        <b-dropdown-item
          :data-test="`edit-campaign-group-link-${index}`"
          @click="onDeleteCampaignGroupClick"
        >
          Delete Campaign Group
        </b-dropdown-item>
      </div>
    </b-dropdown>

    <ShareGroupModal
      id="modalGroupSharingCampaign"
      ref="modalGroupSharingCampaign"
      :share-type="shareType"
      :advertiser-id="advertiserId"
      :group="group"
    />

    <EditCampaignToGroupModal
      id="modalEditCampaignGroup"
      ref="modalEditCampaignGroup"
      :advertiser-id="advertiserId"
      :group="group"
      @refreshTable="refreshTable"
    />

    <DeleteCampaignToGroupModal
      id="modalDeleteCampaignGroup"
      ref="modalDeleteCampaignGroup"
      :advertiser-id="advertiserId"
      :group="group"
      @refreshTable="refreshTable"
    />
  </div>
</template>

<script>
import ShareGroupModal from '@/modules/share/components/ShareGroupModal';
import EditCampaignToGroupModal from './EditCampaignGroupModal';
import DeleteCampaignToGroupModal from './DeleteCampaignGroupModal';
import { mapActions, mapGetters, mapState } from 'vuex';

import * as campaignTypes from '@/modules/campaigns/store/types';
import * as accountTypes from '@/modules/account/store/types';
import * as authenticationTypes from '@/modules/authentication/store/types';

export default {
  name: 'CampaignGroupActions',
  components: {
    EditCampaignToGroupModal,
    DeleteCampaignToGroupModal,
    ShareGroupModal,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    advertiserId: {
      type: Number,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
    isMyDashboard: {
      type: Boolean,
      default: true,
    },
    areAllCampaignsFullAccess: {
      type: Boolean,
      default: false,
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      hasViewReportingAccess: false,
      minAvailableDateForReports: process.env.VUE_APP_MIN_AVAILABLE_REPORTING_DATE,
    };
  },
  computed: {
    ...mapState('account', {
      accountProperties: 'properties',
    }),
    ...mapGetters('account', [
      accountTypes.GET_IS_MANAGED_ACCOUNT,
    ]),
    ...mapGetters('authentication', [
      authenticationTypes.GET_IS_ADMIN,
    ]),
    isReportingDashboardV1Available() {
      const reportingDashboardVersion = this.accountProperties.reportDashboardVersion;
      return !this.GET_IS_ADMIN || reportingDashboardVersion !== 'v2';
    },
    optionIsVisible() {
      return this.isMyDashboard || this.areAllCampaignsFullAccess;
    },
    shareType() {
      return this.GET_IS_MANAGED_ACCOUNT ? 'REPORTING' : 'CAMPAIGN';
    },
    statsDataIsPresent() {
      return this.campaigns.some((campaign) => campaign.endDate >= this.minAvailableDateForReports);
    },
    areAllCampaignsDraftOrReview() {
      return this.campaigns.every((campaign) => campaign.state === 'DRAFT' || campaign.state === 'REVIEW');
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_CAMPAIGN_ACCESS,
    ]),
    onShareCampaignGroupClick() {
      this.$refs.modalGroupSharingCampaign.showModal();
    },
    onEditCampaignGroupClick() {
      this.$refs.modalEditCampaignGroup.showModal();
    },
    onDeleteCampaignGroupClick() {
      this.$refs.modalDeleteCampaignGroup.showModal();
    },
    refreshTable() {
      this.$emit('refreshTable');
    },
  },
  mounted() {
    const campaignIds = this.campaigns.map((campaign) => campaign.id);
    if (campaignIds.length === 0) return;
    Promise.all(campaignIds.map((campaignId) => this.FETCH_CAMPAIGN_ACCESS(campaignId))).then((accessResponses) => {
      this.hasViewReportingAccess = accessResponses
        .every((accessResponse) => accessResponse.ownerAccess || (accessResponse.shareTypes.includes('CAMPAIGN')
          || accessResponse.shareTypes.includes('REPORTING')));
    });
  },
};
</script>
